module.exports = __webpack_public_path__ + "img/ic-tuktuk-arrow-left.a5d5a9cb.svg";